import React, { useEffect, useState } from "react";
import beauty from "../../assets/beauty_white.png";
import beauty1 from "../../assets/beauty1.png";
import glove1 from "../../assets/glove1.png";
import glove from "../../assets/glove.png";
import fit from "../../assets/fit.png";
import fit1 from "../../assets/fit1.png";
import apple from "../../assets/apple.png";
import apple1 from "../../assets/apple1.png";
import sex from "../../assets/sex.png";
import sex1 from "../../assets/sex1.png";
import yoga from "../../assets/yoga.png";
import yoga1 from "../../assets/yoga1.png";
import sleep from "../../assets/sleep.png";
import sleep1 from "../../assets/sleep1.png";
import travel from "../../assets/travel.png";
import travel1 from "../../assets/travel1.png";
import home from "../../assets/home.png";
import home1 from "../../assets/home1.png";
import Breadcrumbs from "../Breadcrumbs";
import "./tools.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
function Dos({ selectedTool, setSelectedTool }) {
   
  const images = [
    {
      default: beauty1,
      hover: beauty,
      label: "Beauty and Style",
      path: "beauty-style",
    },
    { default: glove, hover: glove1, label: "Health", path: "health" },
    { default: fit, hover: fit1, label: "Fitness", path: "fitness" },
    {
      default: apple,
      hover: apple1,
      label: "Nutrition and weight",
      path: "wellness",
    },
    { default: sex, hover: sex1, label: "Conception", path: "conception" },
    { default: yoga, hover: yoga1, label: "Yoga", path: "yoga" },
    { default: sleep, hover: sleep1, label: "Sleep", path: "sleep" },
    { default: travel, hover: travel1, label: "Travel", path: "travel" },
    {
      default: home,
      hover: home1,
      label: "Home&work",
      path: "housework",
    },
  ];

  const [imageSrc, setImageSrc] = useState(
    images.reduce((acc, img, index) => {
      acc[index] = img.default;
      return acc;
    }, {})
  );

  const handleMouseEnter = (index) => {
    setImageSrc((prev) => ({
      ...prev,
      [index]: images[index].hover,
    }));
  };

  const handleMouseLeave = (index) => {
    setImageSrc((prev) => ({
      ...prev,
      [index]: images[index].default,
    }));
  };

  useEffect(()=>{
   setSelectedTool("dos-donts")
  },[])

  return (
    <div className="dos-base">
      <Helmet>
        <title>Secrets to Easily Navigating Pregnancy Do's & Don'ts</title>
        <meta
          name="description"
          content="Find the essential do's and don'ts during pregnancy to ensure a healthy journey for both mother and baby. Your complete guide to informed choices awaits!
"
        />
        <meta
          name="keywords"
          content="Pregnancy safety tips, pregnancy do’s and don’ts, pregnancy health, pregnancy fitness, pregnancy sex, pregnancy yoga, pregnancy workouts"
        />
      </Helmet>
      <div className="dos-cont">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link to="/" className="breadcrumb-link" onClick={()=>setSelectedTool("")}>
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Dos&Donts</li>
            </ol>
          </nav>
        </div>
        <div className="box-do">
          {images.map((image, index) => (
            <Link to={image.path} key={index} className="card-do-link">
              <div
                className="card-do"
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={() => handleMouseLeave(index)}
              >
                <img
                  src={imageSrc[index]}
                  style={{ width: "50px", height: "70px" }}
                  alt={image.label}
                />
                <h6
                  style={{ marginTop: "15px", marginLeft: "-30px" }}
                  id="dos-color-change"
                >
                  {image.label}
                </h6>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Dos;
